import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out
  const [token, setToken] = useState(() => localStorage.getItem("tk_token") || null);

  const check = useCallback(async () => {
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
    } catch (err) {
      console.error("Auth check failed", err);
      setUser(false);
    }
  }, [token]);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) {
      localStorage.setItem("tk_token", data.token);
      setToken(data.token);
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed", err);
    }
    localStorage.removeItem("tk_token");
    setToken(null);
    setUser(false);
  };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider value={{ user, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
